'use strict';

//dependencies included for running in node
if (typeof exports !== 'undefined') {
	if (typeof module !== 'undefined' && module.exports) {
		var AdvDate = require('js-utils/src/util/advDate');
	}
}

var ModelOutput = function(index) {
	this.start = index === undefined ? 0 : index;
	this.index = [];
	this.history = [];
	this.deflator = null;
	this.deflationPeriod = 0;
};

//use deflated outputs in ModelOutput
// pass in deflation rate and optional time period if deflation time period is not aligned
// with the time the output spans
ModelOutput.prototype.useDeflatedOutput = function(deflator, period) {
	//output cash flows are monthly so convert annual discount rate to a monthly one
	this.deflator = Math.pow(1 + deflator, 1 / AdvDate.MONTHS_IN_YEAR) - 1;
	this.deflationPeriod = period !== undefined ? period : this.deflationPeriod;
};

ModelOutput.prototype.setValue = function(value) {
	if(this.deflator !== null) {
		value = (value / Math.pow(1 + this.deflator, this.index.length + this.deflationPeriod));
	}

	this.index.push(this.start + this.history.length);
	this.history.push(value);
};

ModelOutput.prototype.getValue = function() {
	return this.history[this.history.length - 1];
};

ModelOutput.prototype.getFullHistory = function() {
	return this.history;
};

//returns a range of the output history
// selection is relative to indexStart
// e.g. if indexStart is 35
//  getHistoryBetween(35,45) will return the first 10 elements
ModelOutput.prototype.getHistoryBetween = function(start, end) {
	var sliceStart = this.index.indexOf(start);
	var sliceEnd = this.index.indexOf(end);
	return sliceStart > -1 && sliceEnd > -1 && sliceStart <= sliceEnd ? this.history.slice(sliceStart, sliceEnd + 1) : NaN; 
};

ModelOutput.prototype.getHistoryAt = function(index) {
	var historyIndex = this.index.indexOf(index);
	return historyIndex > -1 ? this.history[historyIndex] : NaN;
};

ModelOutput.prototype.length = function() {
	return this.history.length;
};

ModelOutput.prototype.indexStart = function() {
	return this.start;
};

ModelOutput.prototype.indexEnd = function() {
	return this.index[this.index.length - 1];
};

//Node module export
if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
        exports = module.exports = ModelOutput;
    }
    exports.ModelOutput = ModelOutput;
}